// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_534d74f"};